import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "State/store";

interface CartIconButtonProps {
  onClick?: () => void;
}

/** Navbar cart icon with the total-quantity badge. */
const CartIconButton: React.FC<CartIconButtonProps> = ({ onClick }) => {
  const cartList = useSelector((state: RootState) => state.cart.cartList);
  const totalQuantity = cartList.reduce(
    (total, item) => total + (item.quantity || 0),
    0,
  );

  return (
    <div
      className="relative cursor-pointer"
      onClick={onClick}
      aria-label="Open mini cart"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        className="lucide lucide-shopping-cart text-yellow-600"
      >
        <circle cx="8" cy="21" r="1" />
        <circle cx="19" cy="21" r="1" />
        <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12" />
      </svg>

      {totalQuantity > 0 && (
        <span
          className="absolute right-[-6px]
        top-[-1px]       /* MOBILE - visually matches desktop */
        sm:top-[-4px]    /* DESKTOP - perfect baseline alignment */
       bg-red-500 text-white text-[10px] leading-none min-w-[16px] h-[16px]
       flex items-center justify-center rounded-full font-semibold"
        >
          {totalQuantity}
        </span>
      )}
    </div>
  );
};

export default CartIconButton;
